// services/settings/paymentApi.js
import axiosInstance from "../server/axios";

const token = localStorage.getItem('authToken');

export const getPaymentTypes = () => {
    return axiosInstance.get('/payment-settings', {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        }
    });
};

export const updatePaymentType = (data) => {
    return axiosInstance.post('/payment-settings/update', data, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        }
    });
};

export const updateMultiplePaymentTypes = (data) => {
    return axiosInstance.post('/payment-settings/update-multiple', data, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        }
    });
};